import type { Distance, Pixel, SpatialRectangle } from "@pdfking/renderer-api"
import { RecordMap } from "@pdfking/tfunc"

import type { PdfEngineOptions } from "../types/engine/PdfEngineOptions"

export const ConvertRectangle = (
  options: PdfEngineOptions,
  rect: SpatialRectangle<Pixel>
): SpatialRectangle<Distance> =>
  RecordMap(
    rect,
    (v, k) => k,
    value => (value / options.unit_to_px) as Distance
  )
